<div class="card review-cards">
    <div class="card-body">
        <div class="card-title">
            <span *ngFor="let item of [].constructor(review.rating); let i = index">
                <ion-icon name="star" color="primary"></ion-icon>
            </span>
            <div class="chip" *ngIf="review?.type === 'mid'">Mid-Rotation Review</div>
        </div>
        <span class="content"> {{ getFirstName(review?.name) }} says: </span>

        <div class="mt-2">
            <div class="content" [innerHTML]="review.content | safe : 'html'"></div>
        </div>
    </div>
</div>
